import { get, post } from './request'

/** 获取 VIP 套餐列表 */
export function getVipPlans() {
  return get('/vip/plans')
}

/** 获取当前用户 VIP 状态 */
export function getVipStatus() {
  return get('/vip/status')
}

/** 创建会员购买订单（选择套餐 + 支付方式） */
export function subscribeVip(data) {
  return post('/vip/subscribe', data)
}

/** 确认支付完成（后端开通会员） */
export function confirmVipPay(data) {
  return post('/vip/pay/confirm', data)
}

/** 取消支付 */
export function cancelVipPay(data) {
  return post('/vip/pay/cancel', data)
}

/** 支付宝电脑网站支付：获取跳转 URL（需登录） */
export function createAlipayPcPay(data) {
  return post('/payment/alipay/pc', data)
}

/** 查询订单支付状态（轮询，需登录） */
export function getAlipayOrderStatus(purchaseId) {
  return get('/payment/alipay/order-status', {
    purchase_id: purchaseId
  })
}

/** 微信 Native 支付：获取二维码链接（需登录） */
export function createWechatNativePay(data) {
  return post('/payment/wechat/native', data)
}

/** 查询微信订单支付状态（轮询，需登录） */
export function getWechatOrderStatus(purchaseId) {
  return get('/payment/wechat/order-status', {
    purchase_id: purchaseId
  })
}

/** 获取购买记录（与 uni-user-app 一致：GET /purchases） */
export function getPurchases(params = {}) {
  return get('/purchases', params)
}
